import { ICustomInspectionTypeSettings } from '../ICustomInspectionTypeSettings';
import { nen3140ScoreToColorCode } from './nen3140ScoreToColorCode';

const translation = {
    en: {
        nen3140: {
            nen3140: 'Electrical installation (NEN 3140)',
            nen3140Result: 'Assessments',
            isElectricalInstallation: 'Is electrical installation',
            filterOnElectricalInstallation: 'Filter electrical installation',
            visualsAndDocuments: 'Visuals and documents',
        },
        inspectionStandard: {
            nen3140: 'Electrical installation (NEN 3140 )',
        },
    },
    nl: {
        nen3140: {
            nen3140: 'Elektrische installatie (NEN 3140)',
            nen3140Result: 'Beoordelingen',
            isElectricalInstallation: 'Is elektrische installatie',
            filterOnElectricalInstallation: 'Filter elektrische installatie',
            visualsAndDocuments: 'Afbeeldingen en documenten',
        },
        inspectionStandard: {
            nen3140: 'Elektrische installatie (NEN 3140)',
        },
    },
};

export function conditionScoreToScore(conditionScore?: number | null | string) {
    if (conditionScore === undefined || conditionScore === null) {
        return null;
    }
    switch (conditionScore.toString()) {
        case '0':
            return 'OK';
        case '1':
            return 'A';
        case '2':
            return 'B';
        case '3':
            return 'C';
        case '4':
            return 'D';
        case '5':
            return 'E';
        case '6':
            return 'F';
        case '7':
            return 'NVT';
        default:
            return null;
    }
}

export function conditionScoreToColorCode(conditionScore?: number | null | string) {
    const score = conditionScoreToScore(conditionScore);
    return nen3140ScoreToColorCode(score);
}

export const nen3140Settings: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'nen3140',
    translation,
    conditionScoreToScore,
    conditionScoreToColorCode,
};
